import {
  FieldsGroup,
  TabItem,
  TemplateParentTypeEnum,
  WidgetTypeConfig,
} from '@/types';
// V3
// eslint-disable-next-line import/no-cycle
import emailSocialMediaFieldsConfig from '@/components/template-builder/config/templates/email/widgets/widget-social-media-fields-config';
// eslint-disable-next-line import/no-cycle
import displaySocialMediaFieldsConfig from '@/components/template-builder/config/templates/display/widgets/widget-social-media-fields-config';
// V4
// eslint-disable-next-line import/no-cycle
import emailSocialMediaFieldsConfigV4 from '@/components/template-builder/config/templates/email-v4/widgets/widget-social-media-fields-config';
// eslint-disable-next-line import/no-cycle
import displaySocialMediaFieldsConfigV4 from '@/components/template-builder/config/templates/display-v4/widgets/widget-social-media-fields-config';

const getWidgetSocialMediaConfig = (templateType: TemplateParentTypeEnum, isV4 = false): WidgetTypeConfig => {
  let fieldItems: Array<FieldsGroup | TabItem> = [];
  switch (templateType) {
    case TemplateParentTypeEnum.POPUP:
    case TemplateParentTypeEnum.EMBED:
      fieldItems = isV4 ? displaySocialMediaFieldsConfigV4 : displaySocialMediaFieldsConfig;
      break;
    default:
      fieldItems = isV4 ? emailSocialMediaFieldsConfigV4 : emailSocialMediaFieldsConfig;
  }
  return {
    tabPanel: {
      label: 'templateBuilder.widgetsHeaders.socialMedia',
      items: fieldItems,
    },
  };
};

export default getWidgetSocialMediaConfig;
